// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IGroupingRecordInfoDto
 */
export interface IGroupingRecordInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IGroupingRecordInfoDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IGroupingRecordInfoDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IGroupingRecordInfoDto
     */
    ee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IGroupingRecordInfoDto
     */
    er_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IGroupingRecordInfoDto
     */
    contribution_group_status?: IGroupingRecordInfoDtoContributionGroupStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IGroupingRecordInfoDtoContributionGroupStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    ERROR = 'ERROR',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    APPROVAL_NEEDED = 'APPROVAL_NEEDED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}


/**
 * Check if a given object implements the IGroupingRecordInfoDto interface.
 */
export function instanceOfIGroupingRecordInfoDto(value: object): value is IGroupingRecordInfoDto {
    return true;
}

export function IGroupingRecordInfoDtoFromJSON(json: any): IGroupingRecordInfoDto {
    return IGroupingRecordInfoDtoFromJSONTyped(json, false);
}

export function IGroupingRecordInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IGroupingRecordInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'ee_contribution_amount': json['ee_contribution_amount'] == null ? undefined : json['ee_contribution_amount'],
        'er_contribution_amount': json['er_contribution_amount'] == null ? undefined : json['er_contribution_amount'],
        'contribution_group_status': json['contribution_group_status'] == null ? undefined : json['contribution_group_status'],
    };
}

export function IGroupingRecordInfoDtoToJSON(json: any): IGroupingRecordInfoDto {
    return IGroupingRecordInfoDtoToJSONTyped(json, false);
}

export function IGroupingRecordInfoDtoToJSONTyped(value?: IGroupingRecordInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_code': value['plan_code'],
        'invoice_id': value['invoice_id'],
        'ee_contribution_amount': value['ee_contribution_amount'],
        'er_contribution_amount': value['er_contribution_amount'],
        'contribution_group_status': value['contribution_group_status'],
    };
}

